import {Pagination, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import theme from 'src/styles/theme';
import {APP} from 'src/styles/variables';

export const DataGridComponentDiv = styled('div')`
  margin: 1rem;
  box-shadow:
    (0 0 0 / 20%) 0px 2px 1px -1px,
    rgb(0 0 0 / 14%) 0px 1px 1px 0px,
    rgb(0 0 0 / 12%) 0px 1px 3px;
`;

export const ColumnDataGridComponentDiv = styled('div')`
  box-shadow:
    (0 0 0 / 20%) 0px 2px 1px -1px,
    rgb(0 0 0 / 14%) 0px 1px 1px 0px,
    rgb(0 0 0 / 12%) 0px 1px 3px;

  .MuiDataGrid-columnHeaderTitleContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const DetailPanelDiv = styled('div')`
  font-size: 14;
  font-weight: bold;
  padding-bottom: 10;
  margin: 1rem;
  text-transform: capitalize;
`;

export const PaginationStyle = styled(Pagination)`
  .MuiPagination-ul {
    width: auto;
    flex-wrap: initial !important;

    .MuiPaginationItem-root.Mui-selected {
      height: 31px !important;
      // color: ${theme.palette.primary.light} !important;
      // background-color: ${theme.palette.primary.dark} !important;

      '&:hover': {
        height: 31px !important;
        color: ${APP.PALETTE.PRIMARY.CONTRAST_TEXT} !important;
        background-color: ${APP.PALETTE.PAGINATION_COLOR.MAIN} !important;
      }
    }
  }
`;

export const RowsCountDivStyle = styled('div')`
  font-size: 14px;
  display: flex;
  width: 100%;
  line-height: initial;
  justify-content: flex-start;
  align-items: initial;
  // margin-left: 2rem;
`;

export const TablePaginationWrapper = styled('div')`
  .MuiTablePagination-selectLabel {
    width: max-content;
  }
  .MuiTablePagination-actions {
    display: none;
  }
  .MuiTablePagination-displayedRows {
    display: none;
  }
`;

export const RenderTabsDiv = styled('div')`
  width: '100%';
  height: '100%';
  overflow: 'hidden';
  padding: 0.5rem;
  // margin-left: '1.2rem'
`;

export const RenderTabsContentDiv = styled('div')`
  max-height: '40rem';
  overflow: 'auto';
  flex: 1;
`;

export const DetailPanelContentDiv = styled('div')``;

export const RenderMainSectionDiv = styled('div')``;

export const RenderListDiv = styled('div')`
  margin: '1rem 0 1rem 4rem';
`;

export const RenderListUL = styled('ul')`
  padding-left: '1.5rem';
  padding-bottom: '1rem';
`;

export const RenderListLI = styled('li')`
  padding: '0.2rem';
`;

export const DataGridToolTipTypography = styled(Typography)`
white-space: pre-line;
font-size: 12px !important;
padding: 8px !important;
color: white;
text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.62);
overflow-wrap: break-word; /* Enable word-wrap for long words */
word-wrap: break-word; /* Additional support for older browsers */
hyphens: auto; /* Enable hyphenation if supported */
`;
